/**
 * Created by Ivan on 22.05.2025
 */

cleverapps.InitByType["solitaire"] = function () {
    cleverapps.tutorial.register(InitTutorial()); // 1
    cleverapps.tutorial.register(HandTutorial()); // 2
    cleverapps.tutorial.register(ComboTutorial()); // 3
    cleverapps.tutorial.register(WildCardTutorial()); // 6
    cleverapps.tutorial.register(FillHandCardTutorial()); // 13
    cleverapps.tutorial.register(JackpotTutorial()); // 16
    cleverapps.tutorial.register(IceTutorial()); // 23
    cleverapps.tutorial.register(IncDecTutorial()); // 29
    cleverapps.tutorial.register(KeyLockTutorial()); // 40
    cleverapps.tutorial.register(DogStreakTutorial()); // 46
    cleverapps.tutorial.register(SharkTutorial()); // 49
    cleverapps.tutorial.register(BombTutorial()); // 53
    cleverapps.tutorial.register(TrumpTutorial()); // 61
    cleverapps.tutorial.register(MagnetTutorial()); // 68
    cleverapps.tutorial.register(DoubleTutorial()); // 87
    cleverapps.tutorial.register(MouseAndCheeseTutorial()); // 106
    cleverapps.tutorial.register(SuitCardTutorial()); // 127
    cleverapps.tutorial.register(FlagTutorial()); // 196
    cleverapps.tutorial.register(CurtainTutorial()); // 1066
    cleverapps.tutorial.register(SafeTutorial()); // 1111

    cleverapps.tutorial.register(UndoBoosterTutorial());
    cleverapps.tutorial.register(ExtraHandTutorial());
};